import { useEffect, useState } from 'react';
import axios from 'axios';
import {
  ensureBrowserSession,
  getSessionSnapshot,
  installBrowserSession,
  logoutBrowserSession,
  subscribeSession,
  updateSessionUser,
} from '@crewmates/api-client-legacy';
import constant from '../_config/constant';

installBrowserSession({ axiosInstance: axios, baseUrl: constant.apiUrl });

export function useBrowserSession() {
  const [session, setSession] = useState(getSessionSnapshot());
  useEffect(() => {
    const unsubscribe = subscribeSession(setSession);
    ensureBrowserSession();
    return unsubscribe;
  }, []);
  return session;
}

// Single source of truth for "this session may use the admin app". PublicRoute and
// PrivateRoute must agree: when PublicRoute redirected on plain `authenticated`
// while PrivateRoute also required the Admin role, any authenticated non-admin
// session ping-ponged between / and /profile until React aborted the render.
// That is reachable in normal use — every Crewmates app talks to the same API
// host, so one browser carries one session cookie across all three.
export function isAdminSession(session) {
  return Boolean(
    session &&
      session.status === 'authenticated' &&
      session.user &&
      session.user.type === 'Admin',
  );
}

export { ensureBrowserSession, getSessionSnapshot, logoutBrowserSession, updateSessionUser };
